export const REALTIME_V1_DEFAULT_URL = "wss://realtime.sealevel.dev/v1";
